export function initToc(scope) {
  const roots = (scope || document).querySelectorAll('.etp-toc');
  roots.forEach((toc) => {
    const toggleBtn = toc.querySelector('.etp-toc__toggle');
    const body = toc.querySelector('.etp-toc__body');
    if (!toggleBtn || !body || toggleBtn.dataset.etpTocReady) return;

    toggleBtn.dataset.etpTocReady = 'true';
    toggleBtn.addEventListener('click', () => {
      const collapsed = toc.classList.toggle('is-collapsed');
      toggleBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });
}

// Aligned with SCSS bp-m (M/L tier boundary).
const TOC_BREAKPOINT = 1280;

/**
 * Reposition the TOC element between sidebar (desktop) and main content (mobile).
 * Below the breakpoint the TOC moves after the audio player or after the H1 title
 * and collapses automatically. Above the breakpoint it returns to the sidebar and expands.
 */
export function initTocReposition() {
  const containers = document.querySelectorAll('.etp-sidebar-container');
  if (!containers.length) return;

  containers.forEach((container) => {
    const sidebar = container.querySelector('.etp-sidebar-container__sidebar');
    const main    = container.querySelector('.etp-sidebar-container__main');
    const toc     = container.querySelector('.etp-toc');
    if (!sidebar || !main || !toc) return;

    // Avoid double-init
    if (toc.dataset.etpRepositionReady) return;
    toc.dataset.etpRepositionReady = 'true';

    let currentPosition = 'sidebar'; // track where the TOC currently lives

    function reposition() {
      const isMobile = window.innerWidth <= TOC_BREAKPOINT;

      if (isMobile && currentPosition !== 'main') {
        // Find insertion target: after audio player, or after the container holding the first H1
        const audioPlayer = main.querySelector('.etp-type-3-audio-player');
        let titleAnchor   = main.querySelector('.etp-title');
        if (!titleAnchor) {
          const h1 = main.querySelector('h1');
          // Use the parent wrapper (direct child of main) rather than the h1 itself
          titleAnchor = h1 ? h1.closest('.etp-sidebar-container__main > *') : null;
        }
        const anchor = audioPlayer || titleAnchor;

        if (anchor) {
          anchor.insertAdjacentElement('afterend', toc);
        } else {
          main.prepend(toc);
        }

        // Collapse
        toc.classList.add('is-collapsed');
        const btn = toc.querySelector('.etp-toc__toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');

        currentPosition = 'main';
      } else if (!isMobile && currentPosition !== 'sidebar') {
        // Move back to sidebar
        sidebar.prepend(toc);

        // Expand
        toc.classList.remove('is-collapsed');
        const btn = toc.querySelector('.etp-toc__toggle');
        if (btn) btn.setAttribute('aria-expanded', 'true');

        currentPosition = 'sidebar';
      }
    }

    // Initial positioning
    reposition();

    // Listen for resize
    window.addEventListener('resize', reposition);
  });
}

export function initTocbot(scope) {
  const navs = (scope || document).querySelectorAll('.brxe-etp-toc nav[data-heading-selectors]');
  navs.forEach((nav) => {
    if (nav.dataset.etpTocbotReady) return;
    nav.dataset.etpTocbotReady = 'true';

    if (typeof tocbot === 'undefined') return;

    const container = nav.closest('.etp-sidebar-container');
    const mainArea  = container ? container.querySelector('.etp-sidebar-container__main') : null;
    if (!mainArea) return;

    if (!mainArea.id) {
      mainArea.id = 'etp-toc-content-' + nav.id;
    }

    // Assign IDs to headings that don't have one (required for tocbot anchors)
    const headingSelector = nav.dataset.headingSelectors || 'h2, h3, h4';
    const headingsOffset  = parseInt(nav.dataset.headingsOffset) || 0;
    const usedIds = {};
    mainArea.querySelectorAll(headingSelector).forEach((heading) => {
      if (!heading.id) {
        const base = heading.textContent
          .trim()
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '') || 'heading';
        let id = base;
        if (usedIds[id] !== undefined) {
          usedIds[id]++;
          id = base + '-' + usedIds[id];
        } else {
          usedIds[id] = 0;
        }
        heading.id = id;
      }
    });

    tocbot.init({
      tocSelector:        '#' + nav.id,
      contentSelector:    '#' + mainArea.id,
      headingSelector:    nav.dataset.headingSelectors || 'h2, h3, h4',
      ignoreSelector:     nav.dataset.ignoreSelector   || '.toc-ignore',
      headingsOffset:     headingsOffset,
      scrollSmoothOffset: -headingsOffset,
      orderedList:        false,
      scrollSmooth:       true,
    });

  });
}
